import UploadModal from '../../components/uploadModal'
import Gallery from '../../components/imageGallery/gallery'
import { useCarromm } from '../../context/carrom'
import Form from '../../components/form/form'
import DataTable from '../../components/dataTable/dataTable'
import Login from '../login'
//import { useSelector } from 'react-redux'

const Home = () => {
  const carrom = useCarromm()
  const isLogin = carrom?.isLogin
  const previewImages = carrom.previewImages
  const fileDetails = carrom.holdFile
  const handleNext = () => {
    carrom.setTabs(
      carrom.tabs.map(t => ({ ...t, active: t.id === 'backgrounds' }))
    )
  }
  return (
    <>
      <div className='overflow-hidden'>
        {isLogin ? (
          <>
            {/* <h2 className='upload-modal-title'>picDesigner Demo</h2> */}
            <h2 className='upload-modal-title'>Carrom API (Bulk) Testwerkzeug</h2>
            <p className='upload-modal-description'>
              Professionelle Aufnahmen mit wenigen Klicks
            </p>
            <UploadModal handleClick={handleNext} />
            {previewImages && (
              <Gallery items={previewImages} title={'Bilder hochladen'} />
            )}
            <Form />
            {fileDetails?.length > 0 && carrom?.showTable && <DataTable />}
          </>
        ) : (
          <Login />
        )}
      </div>
    </>
  )
}

export default Home
